// extracted by mini-css-extract-plugin
export default {"main":"styles_main__EOXmB","header":"styles_header__ncyiN","header__ttl":"styles_header__ttl__Lo3Nn","header__txt":"styles_header__txt__OAIno"};